module.exports = __webpack_public_path__ + "assets/87178d4feb740a50ad29c8020e0ce2d9.png";